import React from 'react'
import { useState, useEffect } from 'react';
import FormSelect from '../../../../components/forms/formSelect';
import GreenButton from '../../../../components/forms/greenButton';
import ApiUrl from '../../../../configTools/apiUrl';

const Itemsearchscreen = ({Value,allcategoryList,getSearchScreens}) => {
    const User = JSON.parse(localStorage.getItem("user-info"));
    const [typelist, setTypeList] = useState([{name:'Collection', value:'1'},{name:'Hashtag', value:'2'}]);
    const [type,setType] = useState({name:'Collection', value:'1'});
    const [category,setCategory] = useState({name:'Select', value:'0'});
    const [parentCollections, setParentCollections] = useState([]);
    const [image, setImage] = useState('');
    const showPreview = (e) =>{
        if(e.target.files && e.target.files[0]){
            let imageFile = e.target.files[0];
            const formData = new FormData();
            formData.append("file",imageFile);
            fetch(ApiUrl.API_URL_File, {
                method: 'POST',
                body: formData
            })
            .then(res=>res.json())
            .then(data =>{
                if(data.success){
                    setImage(data.url);
                }
                else{
                    console.log(data.responce);
                }
            });
        }
    }
    const post_search = ()=>{
        if(category === '0' || image === ''){
            return;
        }
        let Body = {
            searchid: Value.id,
            collection : parseInt(category.value),
            image : image,
            type : parseInt(type.value)
        };
        fetch(ApiUrl.API_URL_SearchScreenItem, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer '+User.token
            },
            body: JSON.stringify(Body)
        })
        .then(res=>res.json())
        .then(data =>{
            if(data.success){
                alert('added');
                getSearchScreens();
            }
        });
    }
    const delete_item = () =>{
        fetch(ApiUrl.API_URL_SearchScreenDelete,{
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer '+User.token
          },
          body: JSON.stringify({
            id : Value.id,
            collection: Value.collectionid,
            type: Value.type
          })
        })
        .then(res=>res.json())
        .then(data =>{
          if(data.success){
            getSearchScreens();
          }
          else{
            console.log(data.responce);
          }
        });
    }
    const delete_ssitem = (id) =>{
        fetch(ApiUrl.API_URL_SearchScreenItemDelete,{
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer '+User.token
          },
          body: JSON.stringify({
            id:id,
            image:"",
            collection:0,
            searchid:0,
            type : 0
          })
        })
        .then(res=>res.json())
        .then(data =>{
          if(data.success){
            getSearchScreens();
          }
          else{
            console.log(data.responce);
          }
        });
    }
    useEffect(()=>{
        if(type.value !== '1'){
          setType({name:'Collection', value:'1'});
        }
        let collectionListSend = [];
        for (let index = 0; index < allcategoryList.length; index++) {
          const element = allcategoryList[index];
          if(element.parentid === Value.collectionid){
            collectionListSend.push({
                name: element.title,
                value: String(element.id)
            })
          }
        }
        setParentCollections(collectionListSend);
    },[allcategoryList])
    useEffect(()=>{
      setCategory({name:'Select', value:'0'});
      if(type.value === '1'){
        let collectionListSend = [];
        for (let index = 0; index < allcategoryList.length; index++) {
          const element = allcategoryList[index];
          if(element.parentid === 0){
            collectionListSend.push({
                name: element.title,
                value: String(element.id)
            })
          }
        }
        setParentCollections(collectionListSend);
      }
      else{
        fetch(ApiUrl.API_URL_Intrust)
        .then(res=>res.json())
        .then(data =>{
          let collectionListSend = [];
          for (let index = 0; index < data.length; index++) {
            const element = data[index];
            collectionListSend.push({
                name: element.name,
                value: String(element.id)
            })
          }
          setParentCollections(collectionListSend);
        });
      }
    },[type])
  return (
    <>
    <div className='Itemsearchscreen_container'>
        <h3>{Value.title}</h3>
        <div style={{width:"100px"}}>
        <GreenButton Value={'Delete'} Action={delete_item} />
        </div>
    </div>
      <div className='admin_forms_multirow'>
        <div className='admin_col_25'>
            {image === '' &&
                <div className='admin_forms_container'>
                    <label style={{cursor:"pointer"}}>
                        <div style={{
                            width: "100%",
                            paddingTop: "80%",
                            borderRadius: "3px",
                            border: "2px dashed black",
                            position: "relative"
                        }}>
                            <div style={{display:"flex", position:"absolute", top:"0", left:"0", bottom:"0", width:"100%", justifyContent:"center",alignItems:"center"}}>
                                <p>Upload File</p>
                            </div>
                        </div>
                        <input type="file" style={{display:"none"}} onChange={showPreview}/>
                    </label>
                </div>
            }
            {image !== '' &&
                <div className='admin_forms_container'>
                    <div style={{cursor:"pointer"}}>
                        <div style={{
                            backgroundImage:`url(${ApiUrl.API_URL_Image_Collection+image})`,
                            backgroundSize: 'contain',
                            backgroundRepeat: 'no-repeat',
                            backgroundPosition: 'center',
                            width: "100%",
                            paddingTop: "80%",
                            borderRadius: "3px",
                            border: "2px solid black",
                            position:"relative"
                        }}>
                            <div style={{
                                position:"absolute",
                                width:"20%",
                                top:"0",
                                right:"0"
                            }}>
                            <GreenButton Value='X' Action={()=>{
                                setImage('');
                            }}/>
                            </div>
                        </div>
                    </div>
                </div>
            }
            <FormSelect Lable='Type' Value={type} setValue={setType} Options={typelist}/>
            <FormSelect Lable={type.value === '1'?'Category':'Hashtags'} Value={category} setValue={setCategory} Options={parentCollections}/>
            <GreenButton Value={'Add'} Action={()=>{post_search()}}/>
        </div>
        {
            Value.sreachScreenLineItems.map((item,index)=>{
                return(
                    <div className='admin_col_25' key={index}>
                        <div className='admin_forms_container'>
                            <div style={{cursor:"pointer"}}>
                                <div style={{
                                    backgroundImage:`url(${ApiUrl.API_URL_Image_Collection+item.image})`,
                                    backgroundSize: 'contain',
                                    backgroundRepeat: 'no-repeat',
                                    backgroundPosition: 'center',
                                    width: "100%",
                                    paddingTop: "80%",
                                    borderRadius: "3px",
                                    border: "2px solid black",
                                    position:"relative"
                                }}>
                                    <div style={{
                                        position:"absolute",
                                        width:"20%",
                                        top:"0",
                                        right:"0"
                                    }}>
                                    <GreenButton Value='X' Action={()=>{
                                        delete_ssitem(item.id);
                                    }}/>
                                    </div>
                                </div>
                                <div style={{padding:"10px 0px"}}>
                                    <h3>{(item.type===1?'Category-':'Hashtag-')+item.title}</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            })
        }
      </div>
    </>
  )
}

export default Itemsearchscreen
